const interfaceTranslations = {
  selectedCountryAriaLabel: "Seçilen ülke",
  noCountrySelected: "Hiçbir ülke seçilmedi",
  countryListAriaLabel: "Ülke listesi",
  searchPlaceholder: "Ara",
  zeroSearchResults: "Sonuç bulunamadı",
  oneSearchResult: "1 sonuç bulundu",
  multipleSearchResults: "${count} sonuç bulundu",
  // additional countries (not supported by country-list library)
  ac: "Ascension Adası",
  xk: "Kosova"
};
export default interfaceTranslations;